/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvestorRouteImport } from './routes/_investor'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminDeniedRouteImport } from './routes/admin-denied'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvestorUpdatesRouteImport } from './routes/_investor/updates'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminActivityRouteImport } from './routes/admin/activity'
import { Route as AdminCaptableRouteImport } from './routes/admin/captable'
import { Route as AdminFirmsRouteImport } from './routes/admin/firms'
import { Route as AdminOutboxRouteImport } from './routes/admin/outbox'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminUpdatesRouteImport } from './routes/admin/updates'
import { Route as AuthVerifyRouteImport } from './routes/auth.verify'
import { Route as SSlugRouteImport } from './routes/s.$slug'
import { Route as InvestorItemsIdRouteImport } from './routes/_investor/items.$id'
import { Route as InvestorPostsIdRouteImport } from './routes/_investor/posts.$id'
import { Route as InvestorRoomsIndexRouteImport } from './routes/_investor/rooms.index'
import { Route as InvestorRoomsSlugRouteImport } from './routes/_investor/rooms.$slug'
import { Route as AdminDashboardsIndexRouteImport } from './routes/admin/dashboards.index'
import { Route as AdminDashboardsItemIdRouteImport } from './routes/admin/dashboards.$itemId'
import { Route as AdminDatasetsIndexRouteImport } from './routes/admin/datasets.index'
import { Route as AdminDatasetsIdRouteImport } from './routes/admin/datasets.$id'
import { Route as AdminInvestorsIndexRouteImport } from './routes/admin/investors.index'
import { Route as AdminInvestorsIdRouteImport } from './routes/admin/investors.$id'
import { Route as AdminRoomsIndexRouteImport } from './routes/admin/rooms.index'
import { Route as AdminRoomsIdRouteImport } from './routes/admin/rooms.$id'
import { Route as AdminRoomsIdIndexRouteImport } from './routes/admin/rooms.$id.index'
import { Route as AdminRoomsIdActivityRouteImport } from './routes/admin/rooms.$id.activity'
import { Route as AdminRoomsIdAnalyticsRouteImport } from './routes/admin/rooms.$id.analytics'
import { Route as AdminRoomsIdMembersRouteImport } from './routes/admin/rooms.$id.members'
import { Route as AdminRoomsIdSettingsRouteImport } from './routes/admin/rooms.$id.settings'
import { Route as AdminRoomsIdShareRouteImport } from './routes/admin/rooms.$id.share'
import { Route as AdminRoomsIdUpdatesRouteImport } from './routes/admin/rooms.$id.updates'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestorRoute = InvestorRouteImport.update({
  id: '/_investor',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDeniedRoute = AdminDeniedRouteImport.update({
  id: '/admin-denied',
  path: '/admin-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestorUpdatesRoute = InvestorUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => InvestorRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCaptableRoute = AdminCaptableRouteImport.update({
  id: '/captable',
  path: '/captable',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFirmsRoute = AdminFirmsRouteImport.update({
  id: '/firms',
  path: '/firms',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOutboxRoute = AdminOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUpdatesRoute = AdminUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => AdminRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const SSlugRoute = SSlugRouteImport.update({
  id: '/s/$slug',
  path: '/s/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestorItemsIdRoute = InvestorItemsIdRouteImport.update({
  id: '/items/$id',
  path: '/items/$id',
  getParentRoute: () => InvestorRoute,
} as any)
const InvestorPostsIdRoute = InvestorPostsIdRouteImport.update({
  id: '/posts/$id',
  path: '/posts/$id',
  getParentRoute: () => InvestorRoute,
} as any)
const InvestorRoomsIndexRoute = InvestorRoomsIndexRouteImport.update({
  id: '/rooms/',
  path: '/rooms/',
  getParentRoute: () => InvestorRoute,
} as any)
const InvestorRoomsSlugRoute = InvestorRoomsSlugRouteImport.update({
  id: '/rooms/$slug',
  path: '/rooms/$slug',
  getParentRoute: () => InvestorRoute,
} as any)
const AdminDashboardsIndexRoute = AdminDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardsItemIdRoute = AdminDashboardsItemIdRouteImport.update({
  id: '/dashboards/$itemId',
  path: '/dashboards/$itemId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDatasetsIndexRoute = AdminDatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDatasetsIdRoute = AdminDatasetsIdRouteImport.update({
  id: '/datasets/$id',
  path: '/datasets/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvestorsIndexRoute = AdminInvestorsIndexRouteImport.update({
  id: '/investors/',
  path: '/investors/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvestorsIdRoute = AdminInvestorsIdRouteImport.update({
  id: '/investors/$id',
  path: '/investors/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoomsIndexRoute = AdminRoomsIndexRouteImport.update({
  id: '/rooms/',
  path: '/rooms/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoomsIdRoute = AdminRoomsIdRouteImport.update({
  id: '/rooms/$id',
  path: '/rooms/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoomsIdIndexRoute = AdminRoomsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdActivityRoute = AdminRoomsIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdAnalyticsRoute = AdminRoomsIdAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdMembersRoute = AdminRoomsIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdSettingsRoute = AdminRoomsIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdShareRoute = AdminRoomsIdShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)
const AdminRoomsIdUpdatesRoute = AdminRoomsIdUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => AdminRoomsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-denied': typeof AdminDeniedRoute
  '/login': typeof LoginRoute
  '/updates': typeof InvestorUpdatesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/captable': typeof AdminCaptableRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/updates': typeof AdminUpdatesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/s/$slug': typeof SSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/items/$id': typeof InvestorItemsIdRoute
  '/posts/$id': typeof InvestorPostsIdRoute
  '/rooms/$slug': typeof InvestorRoomsSlugRoute
  '/admin/dashboards/$itemId': typeof AdminDashboardsItemIdRoute
  '/admin/datasets/$id': typeof AdminDatasetsIdRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/admin/rooms/$id': typeof AdminRoomsIdRouteWithChildren
  '/rooms/': typeof InvestorRoomsIndexRoute
  '/admin/dashboards/': typeof AdminDashboardsIndexRoute
  '/admin/datasets/': typeof AdminDatasetsIndexRoute
  '/admin/investors/': typeof AdminInvestorsIndexRoute
  '/admin/rooms/': typeof AdminRoomsIndexRoute
  '/admin/rooms/$id/activity': typeof AdminRoomsIdActivityRoute
  '/admin/rooms/$id/analytics': typeof AdminRoomsIdAnalyticsRoute
  '/admin/rooms/$id/members': typeof AdminRoomsIdMembersRoute
  '/admin/rooms/$id/settings': typeof AdminRoomsIdSettingsRoute
  '/admin/rooms/$id/share': typeof AdminRoomsIdShareRoute
  '/admin/rooms/$id/updates': typeof AdminRoomsIdUpdatesRoute
  '/admin/rooms/$id/': typeof AdminRoomsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-denied': typeof AdminDeniedRoute
  '/login': typeof LoginRoute
  '/updates': typeof InvestorUpdatesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/captable': typeof AdminCaptableRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/updates': typeof AdminUpdatesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/s/$slug': typeof SSlugRoute
  '/admin': typeof AdminIndexRoute
  '/items/$id': typeof InvestorItemsIdRoute
  '/posts/$id': typeof InvestorPostsIdRoute
  '/rooms/$slug': typeof InvestorRoomsSlugRoute
  '/admin/dashboards/$itemId': typeof AdminDashboardsItemIdRoute
  '/admin/datasets/$id': typeof AdminDatasetsIdRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/rooms': typeof InvestorRoomsIndexRoute
  '/admin/dashboards': typeof AdminDashboardsIndexRoute
  '/admin/datasets': typeof AdminDatasetsIndexRoute
  '/admin/investors': typeof AdminInvestorsIndexRoute
  '/admin/rooms': typeof AdminRoomsIndexRoute
  '/admin/rooms/$id/activity': typeof AdminRoomsIdActivityRoute
  '/admin/rooms/$id/analytics': typeof AdminRoomsIdAnalyticsRoute
  '/admin/rooms/$id/members': typeof AdminRoomsIdMembersRoute
  '/admin/rooms/$id/settings': typeof AdminRoomsIdSettingsRoute
  '/admin/rooms/$id/share': typeof AdminRoomsIdShareRoute
  '/admin/rooms/$id/updates': typeof AdminRoomsIdUpdatesRoute
  '/admin/rooms/$id': typeof AdminRoomsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_investor': typeof InvestorRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/admin-denied': typeof AdminDeniedRoute
  '/login': typeof LoginRoute
  '/_investor/updates': typeof InvestorUpdatesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/captable': typeof AdminCaptableRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/updates': typeof AdminUpdatesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/s/$slug': typeof SSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/_investor/items/$id': typeof InvestorItemsIdRoute
  '/_investor/posts/$id': typeof InvestorPostsIdRoute
  '/_investor/rooms/$slug': typeof InvestorRoomsSlugRoute
  '/admin/dashboards/$itemId': typeof AdminDashboardsItemIdRoute
  '/admin/datasets/$id': typeof AdminDatasetsIdRoute
  '/admin/investors/$id': typeof AdminInvestorsIdRoute
  '/admin/rooms/$id': typeof AdminRoomsIdRouteWithChildren
  '/_investor/rooms/': typeof InvestorRoomsIndexRoute
  '/admin/dashboards/': typeof AdminDashboardsIndexRoute
  '/admin/datasets/': typeof AdminDatasetsIndexRoute
  '/admin/investors/': typeof AdminInvestorsIndexRoute
  '/admin/rooms/': typeof AdminRoomsIndexRoute
  '/admin/rooms/$id/activity': typeof AdminRoomsIdActivityRoute
  '/admin/rooms/$id/analytics': typeof AdminRoomsIdAnalyticsRoute
  '/admin/rooms/$id/members': typeof AdminRoomsIdMembersRoute
  '/admin/rooms/$id/settings': typeof AdminRoomsIdSettingsRoute
  '/admin/rooms/$id/share': typeof AdminRoomsIdShareRoute
  '/admin/rooms/$id/updates': typeof AdminRoomsIdUpdatesRoute
  '/admin/rooms/$id/': typeof AdminRoomsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin-denied'
    | '/login'
    | '/updates'
    | '/admin/activity'
    | '/admin/captable'
    | '/admin/firms'
    | '/admin/outbox'
    | '/admin/settings'
    | '/admin/updates'
    | '/auth/verify'
    | '/s/$slug'
    | '/admin/'
    | '/items/$id'
    | '/posts/$id'
    | '/rooms/$slug'
    | '/admin/dashboards/$itemId'
    | '/admin/datasets/$id'
    | '/admin/investors/$id'
    | '/admin/rooms/$id'
    | '/rooms/'
    | '/admin/dashboards/'
    | '/admin/datasets/'
    | '/admin/investors/'
    | '/admin/rooms/'
    | '/admin/rooms/$id/activity'
    | '/admin/rooms/$id/analytics'
    | '/admin/rooms/$id/members'
    | '/admin/rooms/$id/settings'
    | '/admin/rooms/$id/share'
    | '/admin/rooms/$id/updates'
    | '/admin/rooms/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-denied'
    | '/login'
    | '/updates'
    | '/admin/activity'
    | '/admin/captable'
    | '/admin/firms'
    | '/admin/outbox'
    | '/admin/settings'
    | '/admin/updates'
    | '/auth/verify'
    | '/s/$slug'
    | '/admin'
    | '/items/$id'
    | '/posts/$id'
    | '/rooms/$slug'
    | '/admin/dashboards/$itemId'
    | '/admin/datasets/$id'
    | '/admin/investors/$id'
    | '/rooms'
    | '/admin/dashboards'
    | '/admin/datasets'
    | '/admin/investors'
    | '/admin/rooms'
    | '/admin/rooms/$id/activity'
    | '/admin/rooms/$id/analytics'
    | '/admin/rooms/$id/members'
    | '/admin/rooms/$id/settings'
    | '/admin/rooms/$id/share'
    | '/admin/rooms/$id/updates'
    | '/admin/rooms/$id'
  id:
    | '__root__'
    | '/'
    | '/_investor'
    | '/admin'
    | '/admin-denied'
    | '/login'
    | '/_investor/updates'
    | '/admin/activity'
    | '/admin/captable'
    | '/admin/firms'
    | '/admin/outbox'
    | '/admin/settings'
    | '/admin/updates'
    | '/auth/verify'
    | '/s/$slug'
    | '/admin/'
    | '/_investor/items/$id'
    | '/_investor/posts/$id'
    | '/_investor/rooms/$slug'
    | '/admin/dashboards/$itemId'
    | '/admin/datasets/$id'
    | '/admin/investors/$id'
    | '/admin/rooms/$id'
    | '/_investor/rooms/'
    | '/admin/dashboards/'
    | '/admin/datasets/'
    | '/admin/investors/'
    | '/admin/rooms/'
    | '/admin/rooms/$id/activity'
    | '/admin/rooms/$id/analytics'
    | '/admin/rooms/$id/members'
    | '/admin/rooms/$id/settings'
    | '/admin/rooms/$id/share'
    | '/admin/rooms/$id/updates'
    | '/admin/rooms/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InvestorRoute: typeof InvestorRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AdminDeniedRoute: typeof AdminDeniedRoute
  LoginRoute: typeof LoginRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  SSlugRoute: typeof SSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_investor': {
      id: '/_investor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof InvestorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-denied': {
      id: '/admin-denied'
      path: '/admin-denied'
      fullPath: '/admin-denied'
      preLoaderRoute: typeof AdminDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_investor/updates': {
      id: '/_investor/updates'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof InvestorUpdatesRouteImport
      parentRoute: typeof InvestorRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/captable': {
      id: '/admin/captable'
      path: '/captable'
      fullPath: '/admin/captable'
      preLoaderRoute: typeof AdminCaptableRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/firms': {
      id: '/admin/firms'
      path: '/firms'
      fullPath: '/admin/firms'
      preLoaderRoute: typeof AdminFirmsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/outbox': {
      id: '/admin/outbox'
      path: '/outbox'
      fullPath: '/admin/outbox'
      preLoaderRoute: typeof AdminOutboxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/updates': {
      id: '/admin/updates'
      path: '/updates'
      fullPath: '/admin/updates'
      preLoaderRoute: typeof AdminUpdatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$slug': {
      id: '/s/$slug'
      path: '/s/$slug'
      fullPath: '/s/$slug'
      preLoaderRoute: typeof SSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_investor/items/$id': {
      id: '/_investor/items/$id'
      path: '/items/$id'
      fullPath: '/items/$id'
      preLoaderRoute: typeof InvestorItemsIdRouteImport
      parentRoute: typeof InvestorRoute
    }
    '/_investor/posts/$id': {
      id: '/_investor/posts/$id'
      path: '/posts/$id'
      fullPath: '/posts/$id'
      preLoaderRoute: typeof InvestorPostsIdRouteImport
      parentRoute: typeof InvestorRoute
    }
    '/_investor/rooms/': {
      id: '/_investor/rooms/'
      path: '/rooms'
      fullPath: '/rooms/'
      preLoaderRoute: typeof InvestorRoomsIndexRouteImport
      parentRoute: typeof InvestorRoute
    }
    '/_investor/rooms/$slug': {
      id: '/_investor/rooms/$slug'
      path: '/rooms/$slug'
      fullPath: '/rooms/$slug'
      preLoaderRoute: typeof InvestorRoomsSlugRouteImport
      parentRoute: typeof InvestorRoute
    }
    '/admin/dashboards/': {
      id: '/admin/dashboards/'
      path: '/dashboards'
      fullPath: '/admin/dashboards/'
      preLoaderRoute: typeof AdminDashboardsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboards/$itemId': {
      id: '/admin/dashboards/$itemId'
      path: '/dashboards/$itemId'
      fullPath: '/admin/dashboards/$itemId'
      preLoaderRoute: typeof AdminDashboardsItemIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/datasets/': {
      id: '/admin/datasets/'
      path: '/datasets'
      fullPath: '/admin/datasets/'
      preLoaderRoute: typeof AdminDatasetsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/datasets/$id': {
      id: '/admin/datasets/$id'
      path: '/datasets/$id'
      fullPath: '/admin/datasets/$id'
      preLoaderRoute: typeof AdminDatasetsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/': {
      id: '/admin/investors/'
      path: '/investors'
      fullPath: '/admin/investors/'
      preLoaderRoute: typeof AdminInvestorsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/investors/$id': {
      id: '/admin/investors/$id'
      path: '/investors/$id'
      fullPath: '/admin/investors/$id'
      preLoaderRoute: typeof AdminInvestorsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rooms/': {
      id: '/admin/rooms/'
      path: '/rooms'
      fullPath: '/admin/rooms/'
      preLoaderRoute: typeof AdminRoomsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rooms/$id': {
      id: '/admin/rooms/$id'
      path: '/rooms/$id'
      fullPath: '/admin/rooms/$id'
      preLoaderRoute: typeof AdminRoomsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rooms/$id/': {
      id: '/admin/rooms/$id/'
      path: '/'
      fullPath: '/admin/rooms/$id/'
      preLoaderRoute: typeof AdminRoomsIdIndexRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/activity': {
      id: '/admin/rooms/$id/activity'
      path: '/activity'
      fullPath: '/admin/rooms/$id/activity'
      preLoaderRoute: typeof AdminRoomsIdActivityRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/analytics': {
      id: '/admin/rooms/$id/analytics'
      path: '/analytics'
      fullPath: '/admin/rooms/$id/analytics'
      preLoaderRoute: typeof AdminRoomsIdAnalyticsRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/members': {
      id: '/admin/rooms/$id/members'
      path: '/members'
      fullPath: '/admin/rooms/$id/members'
      preLoaderRoute: typeof AdminRoomsIdMembersRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/settings': {
      id: '/admin/rooms/$id/settings'
      path: '/settings'
      fullPath: '/admin/rooms/$id/settings'
      preLoaderRoute: typeof AdminRoomsIdSettingsRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/share': {
      id: '/admin/rooms/$id/share'
      path: '/share'
      fullPath: '/admin/rooms/$id/share'
      preLoaderRoute: typeof AdminRoomsIdShareRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
    '/admin/rooms/$id/updates': {
      id: '/admin/rooms/$id/updates'
      path: '/updates'
      fullPath: '/admin/rooms/$id/updates'
      preLoaderRoute: typeof AdminRoomsIdUpdatesRouteImport
      parentRoute: typeof AdminRoomsIdRoute
    }
  }
}

interface InvestorRouteChildren {
  InvestorUpdatesRoute: typeof InvestorUpdatesRoute
  InvestorItemsIdRoute: typeof InvestorItemsIdRoute
  InvestorPostsIdRoute: typeof InvestorPostsIdRoute
  InvestorRoomsSlugRoute: typeof InvestorRoomsSlugRoute
  InvestorRoomsIndexRoute: typeof InvestorRoomsIndexRoute
}

const InvestorRouteChildren: InvestorRouteChildren = {
  InvestorUpdatesRoute: InvestorUpdatesRoute,
  InvestorItemsIdRoute: InvestorItemsIdRoute,
  InvestorPostsIdRoute: InvestorPostsIdRoute,
  InvestorRoomsSlugRoute: InvestorRoomsSlugRoute,
  InvestorRoomsIndexRoute: InvestorRoomsIndexRoute,
}

const InvestorRouteWithChildren = InvestorRoute._addFileChildren(
  InvestorRouteChildren,
)

interface AdminRoomsIdRouteChildren {
  AdminRoomsIdActivityRoute: typeof AdminRoomsIdActivityRoute
  AdminRoomsIdAnalyticsRoute: typeof AdminRoomsIdAnalyticsRoute
  AdminRoomsIdMembersRoute: typeof AdminRoomsIdMembersRoute
  AdminRoomsIdSettingsRoute: typeof AdminRoomsIdSettingsRoute
  AdminRoomsIdShareRoute: typeof AdminRoomsIdShareRoute
  AdminRoomsIdUpdatesRoute: typeof AdminRoomsIdUpdatesRoute
  AdminRoomsIdIndexRoute: typeof AdminRoomsIdIndexRoute
}

const AdminRoomsIdRouteChildren: AdminRoomsIdRouteChildren = {
  AdminRoomsIdActivityRoute: AdminRoomsIdActivityRoute,
  AdminRoomsIdAnalyticsRoute: AdminRoomsIdAnalyticsRoute,
  AdminRoomsIdMembersRoute: AdminRoomsIdMembersRoute,
  AdminRoomsIdSettingsRoute: AdminRoomsIdSettingsRoute,
  AdminRoomsIdShareRoute: AdminRoomsIdShareRoute,
  AdminRoomsIdUpdatesRoute: AdminRoomsIdUpdatesRoute,
  AdminRoomsIdIndexRoute: AdminRoomsIdIndexRoute,
}

const AdminRoomsIdRouteWithChildren = AdminRoomsIdRoute._addFileChildren(
  AdminRoomsIdRouteChildren,
)

interface AdminRouteChildren {
  AdminActivityRoute: typeof AdminActivityRoute
  AdminCaptableRoute: typeof AdminCaptableRoute
  AdminFirmsRoute: typeof AdminFirmsRoute
  AdminOutboxRoute: typeof AdminOutboxRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUpdatesRoute: typeof AdminUpdatesRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminDashboardsItemIdRoute: typeof AdminDashboardsItemIdRoute
  AdminDatasetsIdRoute: typeof AdminDatasetsIdRoute
  AdminInvestorsIdRoute: typeof AdminInvestorsIdRoute
  AdminRoomsIdRoute: typeof AdminRoomsIdRouteWithChildren
  AdminDashboardsIndexRoute: typeof AdminDashboardsIndexRoute
  AdminDatasetsIndexRoute: typeof AdminDatasetsIndexRoute
  AdminInvestorsIndexRoute: typeof AdminInvestorsIndexRoute
  AdminRoomsIndexRoute: typeof AdminRoomsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminActivityRoute: AdminActivityRoute,
  AdminCaptableRoute: AdminCaptableRoute,
  AdminFirmsRoute: AdminFirmsRoute,
  AdminOutboxRoute: AdminOutboxRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUpdatesRoute: AdminUpdatesRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminDashboardsItemIdRoute: AdminDashboardsItemIdRoute,
  AdminDatasetsIdRoute: AdminDatasetsIdRoute,
  AdminInvestorsIdRoute: AdminInvestorsIdRoute,
  AdminRoomsIdRoute: AdminRoomsIdRouteWithChildren,
  AdminDashboardsIndexRoute: AdminDashboardsIndexRoute,
  AdminDatasetsIndexRoute: AdminDatasetsIndexRoute,
  AdminInvestorsIndexRoute: AdminInvestorsIndexRoute,
  AdminRoomsIndexRoute: AdminRoomsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InvestorRoute: InvestorRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AdminDeniedRoute: AdminDeniedRoute,
  LoginRoute: LoginRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  SSlugRoute: SSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
